import SectorsList from '../layout/pages/SectorsCards.vue'
import { createStore } from 'vuex'

export const dataExtinguisher = createStore({
  state: () => {
    return {

      componentActive: SectorsList,
      backToComponent: 'SectorsList',
      pageTitle: 'SETORES',
      pageSubTitle: 'Gerencie seus sistema de emergência por setores',
      buttonActive: true,

      // component anterior
      sectors: [], // list
      sectorId: undefined,
      itemsBySector: [],
      sectorForm: {
        name: undefined,
        category: undefined,
        cod: undefined,
        number: undefined,
        description: undefined,
        priority: undefined,
        image: undefined,
        imageName: undefined,
      },
      itensForm: {
        name: undefined,
        type: undefined,
        category: undefined,
        values: {}, // components form
        images: undefined,
        imagesName: undefined,

        description: undefined,
        check_every: undefined,
        next_check: undefined,
        th_expiration: undefined,
        validity_expiration: undefined
      },
      maintenanceForm: {
        type: undefined,
        values: {},
        checklist: [],
        carried_out_in: undefined,
        images: undefined,
        imagesName: undefined,
      },


      employees: [], // combo
      afastamento: [], // combo
      form: {
        realizado_em: undefined,
        expired_at: undefined,
        employee: undefined,
        type: undefined,
        doc: undefined,
        docName: undefined,
        docOriginalName: undefined,
      },
      afastamento_form: {
        employee: undefined,
        realizado_em: undefined,
        expired_at: undefined,
        type: undefined,
        reason: undefined,
        cid: undefined,
        docName: undefined,
        doc: undefined,
      }
    }
  },
  getters: {
    getActiveComponent: (state) => state.componentActive,
    backToComponent: (state) => state.backToComponent,
    getAfastamento: (state) => state.afastamento,
    getEmployees: (state) => state.employees,
    getTitle: (state) => state.pageTitle,
    getPageSubTitle: (state) => state.pageSubTitle,
    getIfButtonActive: (state) => state.buttonActive,
    getSectors: (state) => state.sectors,
    getItensBySector: (state) => state.itemsBySector,
  },
  mutations: {
    RESET_FORM(state) {
      state.sectorForm.description = undefined
      state.sectorForm.imageName = undefined
      state.sectorForm.category = undefined
      state.sectorForm.priority = undefined
      state.sectorForm.number = undefined
      state.sectorForm.image = undefined
      state.sectorForm.name = undefined
      state.sectorForm.cod = undefined

      state.itensForm.name = undefined
      state.itensForm.type = undefined
      state.itensForm.values = {}
      state.itensForm.description = undefined
      state.itensForm.check_every = undefined
      state.itensForm.next_check = undefined
      state.itensForm.images = undefined
      state.itensForm.imagesName = undefined
      state.itensForm.th_expiration = undefined,
      state.itensForm.validity_expiration = undefined

    },
    SET_COMPONENT_ACTIVE(state, value) {
      state.componentActive = value
    },
    SET_ALL_SECTORS(state, value) {
      state.sectors = []
      state.sectors = value
    },
    SET_PAGE_TITLE(state, value) {
      state.pageTitle = value
    },
    SET_PAGE_SUB_TITLE(state, value) {
      state.pageSubTitle = value
    },
    SET_IF_BUTTON_ACTIVE(state, value) {
      state.buttonActive = value
    },
    SET_BACK_COMPONENT(state, value) {
      state.backToComponent = value
    },
    SET_ITENS_BY_SECTOR(state, value) {
      state.itemsBySector = []
      state.itemsBySector = value
    },
    NEW_ITEM_BY_SECTOR(state, payload) {
      state.itemsBySector.unshift(payload)
    },
    NEW_SECTOR(state, value) {
      console.log(state.sectors);
      state.sectors.unshift(value)
    },
    SET_MAINTENANCES(state, value) {
      state.itensForm.maintenances = []
      state.itensForm.maintenances = [value]
    },
    SET_ITEM_TO_EDIT(state, value) {
      const data = { ...value };

      if (
        data.values != null || 
        data.values != [null] || data.values != '[null]' || 
        data.values != [[]] || data.values != '[[]]'
      ) {
        try {
          const parsed = JSON.parse(data.values);
          data.values = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : {};
        } catch (error) {
          console.error('Erro ao fazer parse do JSON:', error);
          data.values = {};
        }
      }

      // Atualiza o state
      state.itensForm = data;
    },


    SET_AFASTAMENTO(state, value) {
      state.afastamento = value
    },
    SET_EMPLOYEES(state, value) {
      state.employees = value
    },
  },
  actions: {
    resetForm({ commit }) {
      commit('RESET_FORM')
    },
    setAllSectors({ commit }, val) {
      commit('SET_ALL_SECTORS', val)
    },
    setComponentActive({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE', value)
    },
    setPageTitle({ commit }, value) {
      commit('SET_PAGE_TITLE', value)
    },
    setPageSubTitle({ commit }, value) {
      commit('SET_PAGE_SUB_TITLE', value)
    },
    setButtonActive({ commit }, value) {
      commit('SET_IF_BUTTON_ACTIVE', value)
    },
    setBackComponent({ commit }, value) {
      commit('SET_BACK_COMPONENT', value)
    },
    setItemsBySector({ commit }, value) {
      commit('SET_ITENS_BY_SECTOR', value)
    },
    addNewSectorCollect({ commit }, value) {
      commit('NEW_SECTOR', value)
    },
    newItemBySector({ commit }, value) {
      commit('NEW_ITEM_BY_SECTOR', value)
    },
    setItemToEdit({ commit }, value) {
      commit('SET_ITEM_TO_EDIT', value)
    },
    setMaintenances({ commit }, value) {
      commit('SET_MAINTENANCES', value)
    },


    setAfastamento({ commit }, value) {
      commit('SET_AFASTAMENTO', value)
    },
    setEmployees({ commit }, value) {
      commit('SET_EMPLOYEES', value)
    },
  }
})
